import React, { Component } from 'react';
import './DropDown.module.scss';

/*
*   Import Fontawesome
*/
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

class DropDown extends Component {

    constructor() {
        super();
    }
    
    render() { 
        const { width, type, border, lightborder, large } = this.props;
        return ( 
            <div styleName={`select ${type ? type : ''} ${border ? 'border' : ''} ${lightborder ? 'transparentborder' : ''} ${large ? 'large' : ''}`} style={{ width: width, borderRadius: this.props.borderRadius}}>
                {this.props.children}
                <FontAwesomeIcon icon={[ 'far', 'angle-down' ]} styleName='icon'/>
            </div> 
        );
    }
}
 
export default DropDown;